@if (showApplicationStatus | async; as showApplicationStatus) {
   <div class="application-status">
      @if (selectedStatus) {
         <div class="container">
            <div class="cn-app-home">
               <section class="dashboard dashboard--overview">
                  <div class="container">
                     <section>
                        <div class="page-header page-header--center">
                           <h1>{{ selectedStatus.Title }}</h1>
                           <div class="status">
                              <p>
                                 <i [class]="'status__icon fa ' + selectedStatus.Icon"></i>
                              </p>
                              <div [innerHtml]="selectedStatus.Text"></div>
                           </div>
                        </div>
                     </section>
                  </div>
               </section>
            </div>
         </div>
      }
      @if ((isTenant === true && showApplicationStatus === true) || isTenant === false) {
         <div class="featured">
            <div class="container">
               <div class="cn-app-home">
                  @if (showApplicationStatusTitle === false) {
                     <div>
                        <h2 class="cn-app-home-title">{{ title }}</h2>
                        @if (loading) {
                           <div style="height: 100px; position: relative">
                              <!-- <ngx-spinner color="grey" size="medium" [fullScreen]="false" bdColor="rgba(0,0,0,0)"
                                   name="applicantFormSpinner" [showSpinner]="true">
                              </ngx-spinner> -->
                           </div>
                        }
                     </div>
                  }
                  @if (showApplicationStatus) {
                     @for (model of application.applications; track model.applicationId; let i = $index) {
                        <div class="cn-app-home-container">
                           <div class="row">
                              <div class="cn-app-status col-xs-12 col-sm-2">
                                 <p>
                                    <i class="status__icon fa fa-home" aria-hidden="true"></i>
                                 </p>
                                 <p>
                                    <span [id]="'app-status-' + (i + 1)" class="label {{ model.statusClass }}">{{ model.status }}</span>
                                 </p>
                              </div>
                              <div class="col-xs-12 col-sm-6">
                                 <div class="row">
                                    <div class="cn-app-reference col-xs-12 col-sm-6">
                                       {{ model.addressLine1 }}
                                       <br />
                                       {{ model.postCode }}
                                    </div>
                                    <div class="cn-app-reference col-xs-12 col-sm-6">
                                       Application reference
                                       <br />
                                       <strong>{{ model.crmReference }}</strong>
                                    </div>
                                 </div>
                                 @if (model.extraMessage) {
                                    <div class="row">
                                       <div class="col-xs-12">
                                          <p style="white-space: pre-line">{{ model.extraMessage }}</p>
                                       </div>
                                    </div>
                                 }
                              </div>
                              <div class="cn-app-actions col-xs-12 col-sm-4 text-center">
                                 @if (model.showApply) {
                                    <button
                                       [id]="'apply-btn-' + (i + 1)"
                                       type="button"
                                       class="btn btn-primary featured__btn btn-block"
                                       [disabled]="!model.enableApply"
                                       (click)="
                                          apply(model.applicationId, model.crmReference, model.addressLine1, model.applyButtonText, model.applyButtonUrl)
                                       "
                                    >
                                       {{ model.applyButtonText }}
                                    </button>
                                 }

                                 @if (model.showWithdraw) {
                                    <button
                                       [id]="'withdraw-btn-' + (i + 1)"
                                       type="button"
                                       class="btn btn-secondary featured__btn btn-block"
                                       style="position: relative"
                                       [disabled]="!model.enableWithdraw"
                                       (click)="showWithdrawModal(model.applicationId)"
                                    >
                                       <span>Withdraw application</span>
                                    </button>
                                 }
                              </div>

                              <div
                                 class="modal withdraw-modal fade in"
                                 [id]="'withdraw-modal-' + model.applicationId"
                                 tabindex="-1"
                                 role="dialog"
                                 aria-labelledby="modal-label"
                              >
                                 <div class="modal-dialog" role="document">
                                    <div class="modal-content">
                                       <div class="modal-header">
                                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                             <span aria-hidden="true">×</span>
                                          </button>
                                          <h4 class="modal-title" id="modal-label">
                                             <i class="fa fa-info-circle" aria-hidden="true"></i>
                                             <span>Withdraw application</span>
                                          </h4>
                                       </div>
                                       <div class="modal-body">
                                          <p>Are you sure you want to withdraw your application? You will be unable to undo this without calling us.</p>
                                       </div>
                                       <div class="modal-footer">
                                          <button type="button" class="btn btn-secondary" (click)="hideWithdrawModal(model.applicationId)">
                                             No, I don't want to withdraw my application
                                          </button>
                                          <button type="button" class="btn btn-primary" (click)="withdraw(model.applicationId)" [disabled]="isDisabled">
                                             <span>Yes, I'm sure</span>
                                          </button>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     }
                  }

                  @if (application.applications.length < 1) {
                     <section class="dashboard dashboard--overview">
                        <div class="page-header page-header--center">
                           <h1>No Active Applications</h1>
                           <div class="status">
                              <p>
                                 <i class="status__icon fa fa-wpforms" aria-hidden="true"></i>
                              </p>
                              <p>You have <strong>no</strong> active applications with us.</p>
                              <p>Please contact us to start the process.</p>
                           </div>
                        </div>
                     </section>
                  }
               </div>
            </div>
         </div>
      }
   </div>
}
